<template>
  <div id="confirmDialog">
    <v-dialog
      v-model="showTimeoutDialog"
      persistent
      width="unset"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{messages.reservationTimeoutDialogTitle}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text
          class="pt-4"
        >{{messages.reservationTimeoutDialogExtentQuestion}}
          <span role="log" aria-live="polite" class="screen-reader-only">{{messages.reservationTimeoutDialogExtentQuestion}}</span>
        </v-card-text>
        <v-progress-linear
          color="light-blue"
          height="20"
          :value="count * 100 / (initialCount)"
          striped
        >
          <template v-slot:default="{ }">
            <strong>{{ Math.ceil(count) }} {{messages.reservationTimeoutDialogSec}}</strong>
          </template>
        </v-progress-linear>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            ref="confirmButtonReservationTimeout"
            text @click.stop="confirm">{{ messages.reservationTimeoutDialogButtonConfirm}}
            <p class="screen-reader-only" id="ariaText2">{{messages.reservationTimeoutDialogExtentQuestion}} {{ messages.reservationTimeoutDialogButtonConfirm}}</p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'TimeoutDialog',
  props: [
    'showTimeoutDialog',
    'startDecountKey',
    'initialCount'
  ],
  data: () => ({
    inTime: true,
    count: -1,
    myTimer: null
  }),
  computed: {
    ...mapState([
      'funcDebug',
      'messages',
      'selectedLanguage'
    ]),
    progress () {
      return Math.ceil(this.initialCount / this.count)
    }
  },
  watch: {
    startDecountKey () {
      if (this.funcDebug) console.log('TimeoutDialog:watch:startDecountKey')
      this.inTime = true
      this.decount(this.initialCount)
      this.focusConfirmButton()
    }
  },
  methods: {
    focusConfirmButton () {
      this.$nextTick(() => {
        // add label text
        const ariaText2 = document.getElementById('ariaText2').innerHTML
        this.$refs.confirmButtonReservationTimeout.$el.ariaLabel = ariaText2

        this.$nextTick(() => {
          // set focus
          this.$refs.confirmButtonReservationTimeout.$el.focus()
        })
      })
    },
    timedOut () {
      if (this.funcDebug) console.log('TimeoutDialog:methods:timedOut')
      this.$emit('timed-out')
      this.clearCountTimeout()
    },
    confirm () {
      if (this.funcDebug) console.log('TimeoutDialog:methods:confirm')
      if (this.inTime) {
        this.$emit('confirm')
      }
      this.clearCountTimeout()
    },
    clearCountTimeout () {
      if (this.funcDebug) console.log('TimeoutDialog:methods:clearCountTimeout')
      clearTimeout(this.myTimer)
      // this.count = -1
    },
    decount (initialCount) {
      if (this.funcDebug) console.log('TimeoutDialog:methods:decount')
      if (initialCount) {
        this.count = initialCount
      } else {
        this.count--
      }
      if (this.count > 0) {
        clearTimeout(this.myTimer)
        this.myTimer = setTimeout(() => {
          this.decount()
        }, 1000)
      } else {
        this.inTime = false
        this.timedOut()
      }
    }
  },
  mounted () {
    if (this.funcDebug) console.log('TimeoutDialog:mounted')
  }
}
</script>

<style scoped>
  .v-btn {
    background-color: var(--primary-btn-bg-color) !important;
    color: var(--primary-btn-text-color) !important;
    border-radius: 0;
    padding: 0 8px;
    line-height: 18px;
  }
</style>
